// statisticsFilterStoreFactory.ts
import { create, StoreApi, UseBoundStore } from "zustand";
import { StatisticsFilterState } from "./useStatisticsFilterStore";
export type StatisticsFilterStore = UseBoundStore<
  StoreApi<StatisticsFilterState>
>;

export const createStatisticsFilterStore = (calcType?: "amount" | "percent") =>
  create<StatisticsFilterState>((set, get) => ({
    startTime: "07:00",
    endTime: "22:00",
    setStartTime: (val) => set({ startTime: val }),
    setEndTime: (val) => set({ endTime: val }),
    typeOfBookings: ["BOOKER", "CO_PLAYER", "ACTIVITY"], // Default to just one
    setTypeOfBookings: (val) => set({ typeOfBookings: val }),
    typeOfBookingListSort: ["BOOKER", "CO_PLAYER", "ACTIVITY"],
    setTypeOfBookingListSort: (val) => set({ typeOfBookingListSort: val }),
    courts: [],
    permissions: [],
    setCourts: (val) => set({ courts: val }),
    setPermissions: (val) => set({ permissions: val }),
    selectedCourts: [],
    setSelectedCourts: (val) => set({ selectedCourts: val }),
    initialPermissions: [],
    selectedPermissions: [],
    setSelectedPermissions: (val) => set({ selectedPermissions: val }),
    initialCoaches: [],
    coaches: [],
    setCoaches: (val) => set({ coaches: val }),
    selectedCoaches: [],
    setSelectedCoaches: (val) => set({ selectedCoaches: val }),
    redBlueFilter: ["RED", "BLUE"],
    setRedBlueFilter: (val) => set({ redBlueFilter: val }),
    genders: ["M", "F"],
    setGenders: (val) => set({ genders: val }),
    ageStart: 0,
    ageEnd: 100,
    setAgeRange(start, end) {
      set({ ageStart: start, ageEnd: end });
    },
    calcType: calcType || "amount",
    setCalcType: (val) => set({ calcType: val }),
    activityColors: [
      "activity-color-1",
      "activity-color-2",
      "activity-color-3",
      "activity-color-4",
    ],
    setActivityColors: (val) => set({ activityColors: val }),
    resetFilters: () =>
      set((state) => ({
        startTime: "07:00",
        endTime: "22:00",
        typeOfBookings: ["BOOKER", "CO_PLAYER", "ACTIVITY"],
        genders: ["M", "F"],
        ageStart: 0,
        ageEnd: 100,
        calcType: "amount",
        selectedPermissions: state.initialPermissions || [],
        selectedCourts: state.courts || [],
        activityColors: [
          "activity-color-1",
          "activity-color-2",
          "activity-color-3",
          "activity-color-4",
        ],
      })),
  }));
